import type { FilmTiming } from "./timeline";

export const penguinTheme = {
  colors: {
    background: "#FFF8E9",
    trail: "#FF3E86",
    circle: "#1EAAB0",
    vector: "#FF6B4D",
    text: "#23304B",
    muted: "#8191A2",
  },
  timing: {
    intro: 0,
    stages: [2.3, 2.35, 2.6, 3.05],
    outro: 1.7,
    hold: 0.06,
    crossfade: 0.12,
    focusDelay: 0.08,
    focusDuration: 0.52,
  } satisfies FilmTiming,
} as const;

export const PENGUIN_DURATION_SECONDS = 12;
